<template>
  <div class="feedback-panel">
    <div class="feedback-panel__content">
      <div class="feedback-panel__avatar" />
      <div class="feedback-panel__message">
        <h3 class="feedback-panel__message-title">
          {{ isAccepted ? "Ny avtale" : "Annen leverandør valgt" }}
        </h3>
        <p class="feedback-panel__message-text">
          {{
            isAccepted
              ? `Gratulerer! Kunden har signert ditt ${isEstimateRequest ? "estimat" : "tilbud"} og avtalen har blitt opprettet. Les tilbakemeldingen fra kunden under og se hvorfor de valgte akkurat ditt ${isEstimateRequest ? "estimat" : "tilbud"}.`
              : `Kunden har valgt et ${isEstimateRequest ? "estimat" : "tilbud"} fra en annen leverandør. Les tilbakemeldingen under og få nyttig innsikt i hvorfor kunden valgte ${isEstimateRequest ? "estimatet" : "tilbudet"} de signerte.`
          }}
        </p>
      </div>
      <FeedbackReason
        v-if="feedback.reasons"
        :reasons="feedback.reasons"
        :is-estimate-request="isEstimateRequest"
      />
      <FeedbackComment v-if="feedback.comment" :comment="feedback.comment" />
      <PublicActorInfo
        v-if="isPublicActor"
        :public-actor-name="publicActorName || ''"
        :competing-bids="feedback?.competingBids || []"
        :is-estimate-request="isEstimateRequest"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import FeedbackReason from "./FeedbackReason.vue";
import FeedbackComment from "./FeedbackComment.vue";
import PublicActorInfo from "./PublicActorInfo.vue";
import { Feedback, CompetingBid } from "@/custom-types/GeneralTypes";

interface Props {
  title: string;
  feedback: Feedback;
  isPublicActor: boolean;
  publicActorName?: string;
  competingBids?: CompetingBid[];
  isAccepted: boolean;
  isEstimateRequest?: boolean;
}

withDefaults(defineProps<Props>(), {
  isEstimateRequest: false,
});
</script>

<style lang="scss" scoped>
.feedback-panel {
  width: 100%;
  height: 100%;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: "Montserrat", sans-serif;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  &__title {
    color: #1d1d1d;
    font-size: 24px;
    font-weight: 600;
  }

  &__close-button {
    width: 32px;
    height: 32px;
    background: none;
    border: none;
    cursor: pointer;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-bottom: 48px;
  }

  &__avatar {
    width: 96px;
    height: 96px;
    background: #f2f2f2;
    border-radius: 50%;
    align-self: center;
  }

  &__message {
    text-align: center;
  }

  &__message-title {
    color: #1d1d1d;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  &__message-text {
    color: #1d1d1d;
    font-size: 16px;
    font-weight: 400;
  }

  &__actions {
    display: flex;
    justify-content: center;
    gap: 16px;
  }

  &__action-button {
    padding: 12px 24px;
    background-color: #1d1d1d;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    text-transform: uppercase;

    &:hover {
      background-color: #333;
    }
  }
}
</style>
